module.exports = __webpack_public_path__ + "img/goshare.fc30e9a2.png";